namespace GlobalErrorListener {
	export var onGlobalError:Signal<(msg:string, url:string, line:number, col:number, error:any)=>void> = null;
	export function init():void {
		onGlobalError =  new Signal<(msg:string, url:string, line:number, col:number, error:any)=>void>();
	}
	var _suppresOtput:boolean = false;
	export function suppresNextOtput() {
		_suppresOtput = true;
	}
	export function isOutputSupressed():boolean {
		let supress = _suppresOtput;
		_suppresOtput = false;
		return supress;
	}
}